import {
	AUDIT_LOG_REQUEST_GET,
	AUDIT_LOG_RESPONSE_GET_FAIL,
	AUDIT_LOG_RESPONSE_GET_SUCCESS,
} from '../../constants/maintenance/auditLogConstants';

/**
 * Reducer function for managing audit log list.
 *
 * @param {object} state - Current state of the audit log list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */

export const auditLogListReducer = (state = { auditLogs: {} }, action) => {
	switch (action.type) {
		case AUDIT_LOG_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case AUDIT_LOG_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				auditLogs: action.payload,
			};
		case AUDIT_LOG_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
